import cart from './cartReducer.ts';
import header from './headerReducer.ts';
import { currencyReducer } from './currencyReducer.ts';
import { appBannerReducer } from './appBannerReducer.js';
import { drawerReducer } from './drawerReducer.ts';

export default {
    cart,
    currency: currencyReducer,
    appBanner: appBannerReducer,
    drawer: drawerReducer,
    header,
};
